/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructors score the combined points of both their drivers, plus bonuses for pit stop speed and having both drivers finish in the top 10 of qualifying (Teamwork bonus).`)
};

const es_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los constructores obtienen los puntos combinados de ambos pilotos, más bonificaciones por velocidad en paradas en boxes y por tener ambos pilotos en el top 10 de clasificación (bonificación de Trabajo en Equipo).`)
};

const de_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konstrukteure erhalten die kombinierten Punkte beider Fahrer, plus Boni für Boxenstopp-Geschwindigkeit und wenn beide Fahrer in den Top 10 des Qualifyings landen (Teamwork-Bonus).`)
};

const nl_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructeurs verdienen de gecombineerde punten van beide coureurs, plus bonussen voor pitstopsnelheid en wanneer beide coureurs in de top 10 van de kwalificatie eindigen (Teamwork-bonus).`)
};

const fr_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les constructeurs marquent les points combinés de leurs deux pilotes, plus des bonus pour la vitesse d’arrêt au stand et quand les deux pilotes terminent dans le top 10 des qualifications (bonus Travail d’Équipe).`)
};

const it_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I costruttori ottengono i punti combinati di entrambi i piloti, più bonus per la velocità ai pit stop e per avere entrambi i piloti nella top 10 delle qualifiche (bonus Lavoro di Squadra).`)
};

const pt_br2_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os construtores ganham os pontos combinados de ambos os pilotos, mais bônus por velocidade nos pit stops e por terem ambos os pilotos no top 10 da classificação (bônus de Trabalho em Equipe).`)
};

const pt_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os construtores obtêm os pontos combinados de ambos os pilotos, mais bónus pela velocidade nas paragens nas boxes e por terem ambos os pilotos no top 10 da qualificação (bónus de Trabalho de Equipa).`)
};

const ja_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンストラクターは両ドライバーの合計ポイントに加え、ピットストップスピードのボーナスと、両ドライバーが予選トップ10に入った場合のチームワークボーナスを獲得します。`)
};

const zh_f1_points_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车队获得两位车手的合计积分，加上进站速度奖励，以及两位车手均进入排位赛前10的团队合作奖励。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_how_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_how_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_how_p2", locale)
	if (locale === "en") return en_f1_points_how_p2(inputs)
	if (locale === "es") return es_f1_points_how_p2(inputs)
	if (locale === "de") return de_f1_points_how_p2(inputs)
	if (locale === "nl") return nl_f1_points_how_p2(inputs)
	if (locale === "fr") return fr_f1_points_how_p2(inputs)
	if (locale === "it") return it_f1_points_how_p2(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_how_p2(inputs)
	if (locale === "pt") return pt_f1_points_how_p2(inputs)
	if (locale === "ja") return ja_f1_points_how_p2(inputs)
	return zh_f1_points_how_p2(inputs)
};